export const UPPERCASE_REGEX = /\p{Lu}/gu;
export const LOWERCASE_REGEX = /\p{Ll}/gu;
export const DIGITS_REGEX = /[0-9]/g;
export const SPECIAL_CHARS_REGEX = /[!@#$%^&* "'()+,-.\/:;<=>?\\_`{|}\[\]]/g;
export const DATE_RANGE_PARTS_REGEX = /(.+) . (.+)/;
